import * as helper from "../../helpers/get_user_details";
import { FailedToFetchUserResponse } from "../../../constants/error_messages";
import { USER_DETAILS } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { getUserDetails } from "../../api/user_management";

export const initialState = {
  loading: false,
  error: {
    hasError: false,
    errorMessage: "",
  },
  particularUserDetails: {},
  DisplaylistUserData: {},
  showError: false,
};

const UserDetailsSlice = createSlice({
  name: USER_DETAILS,
  initialState,
  reducers: {
    reset: () => {},
  },


  

  extraReducers: (builder) => {
    builder.addCase(getUserDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserDetails.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        state.particularUserDetails = payload?.data?.getUserDetailsListRes[0];
        state.DisplaylistUserData = helper.setToUserData(
          payload?.data?.getUserDetailsListRes[0]
        );
        state.showError = helper.showErrros(
          payload?.data?.getUserDetailsListRes[0]
        );
        state.error.hasError = false;
        state.error.errorMessage = "";
      } else {
        state.error.hasError = true;
        state.error.errorMessage =
          payload?.message ?? FailedToFetchUserResponse;
      }

      state.loading = false;
    });
    builder.addCase(getUserDetails.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.message ?? FailedToFetchUserResponse;
      state.loading = false;
    });
  },
});
export const userDetailsActions = UserDetailsSlice.actions;
export default UserDetailsSlice.reducer;
